/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import Axios from 'axios'
import { useNavigate } from 'react-router-dom'
// import { toast} from 'react-toastify'
// import { attrScore } from "../components/functions/education";

const Persattrscore = (props) => {
  const courseGrp = props.courseGrp;
  const courseid = props.courseid;
  const persid = props.persid;
  const checkPage = props.checkPage;
  // const submit = props.submit;
  const token = JSON.parse(localStorage.getItem('token'))
  const navigate = useNavigate()
  // console.log("props: ", props)
  // const idTokenResult = localStorage.token;

  const [score, setScore] = useState([]);

  const fetchdata = async () => {
    await Axios.get(process.env.REACT_APP_API + `/attrScore/${courseGrp}/${courseid}/${persid}?token=${token}`)
       .then((res) => {
          //  console.log(res.data);
          setScore(res.data);
        })
        .catch((err) => {
          if(err.response.status === 400) {
            // toast.error("กรุณาเข้าระบบใหม่อีกครั้ง");
            localStorage.clear();
            navigate('/')
          } else {
            console.log("err: ", err.response.data)
          }
        });
  }
  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    // if (submit) {
      fetchdata()
    // }
  }, [props]);

  // console.log("persattr", score.persattr)
  const sumattrScore = (persattr, checkPage) => {
    let sum = 0;
    if (checkPage === 1) {
      sum = persattr / 10;
      // console.log("persattr", sum.toFixed(2))
      return sum.toFixed(2);
    }
    sum = (persattr / 40) * 100;
    if (sum >= 70) {
      return "ผ่าน (" + sum.toFixed(0) + ")";
    }
    return "ไม่ผ่าน (" + sum.toFixed(0) + ")";
  };
  return (
    <div>
      {score.map((item, index) => (
        <div key={index}>
          <div>
            {item.persattr === null || item.persattr === 0.00 ? (
              <>
              <h5>-</h5>
              {/* <h5>{item.persattr}</h5> */}
            </>
            ) : (
              sumattrScore(item.persattr, checkPage)
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Persattrscore;
